import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 14l6 -6","key":"svg-0"}],["path",{"d":"M9 8.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-1"}],["path",{"d":"M14 13.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-2"}],["path",{"d":"M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2","key":"svg-3"}]]

const IconReceiptTax = createReactComponent('outline', 'receipt-tax', 'ReceiptTax', __iconNode);

export default IconReceiptTax;